import type { ButtonTextVariant } from '@kanda-libs/ks-design-library';

export const FORM_STEPS = {
  WELCOME: 'Welcome',
  DISCLAIMER: 'Disclaimer',
  ACCEPT_TERMS: 'Accept terms',
  ADDITIONAL_INFO: 'Additional info',
};

export const FORM_STEPS_KEYS = Object.values(FORM_STEPS);

export const DEFAULT_NEXT_BUTTON_PROPS = {
  id: 'continue-application-next-button',
  label: 'Next',
  className: 'w-full',
  icon: 'arrow-right',
  variant: 'gradient' as ButtonTextVariant,
  submit: true,
};

export const YOUR_INFO_CLASS_NAMES = {
  title: 'text-style-e text-neutral-900 mb-6 mt-6 first:mt-0',
  subtitle: 'text-style-g text-neutral-700 mb-6 -mt-2 first:mt-0',
  description: 'text-style-g text-neutral-700 mb-6',
  heading: 'text-style-g-em text-neutral-700 mb-6',
};
